import { ColorPicker } from "./ColorPicker";
import type { ThemeColors } from "@/lib/theme/types";

interface ColorSectionProps {
  title: string;
  colors: (keyof ThemeColors)[];
  values: ThemeColors;
  onChange: (key: keyof ThemeColors, value: string) => void;
}

/**
 * A grouped section of color pickers
 */
export function ColorSection({
  title,
  colors,
  values,
  onChange,
}: ColorSectionProps) {
  return (
    <div className="space-y-1">
      <h4 className="text-sm font-semibold text-foreground mb-2">{title}</h4>
      <div className="space-y-0.5">
        {colors.map((colorKey) => (
          <ColorPicker
            key={colorKey}
            colorKey={colorKey}
            value={values[colorKey]}
            onChange={onChange}
          />
        ))}
      </div>
    </div>
  );
}
